import { render } from "./AlternativeCardList.vue?vue&type=template&id=4f1d3544&scoped=true&ts=true"
import script from "./AlternativeCardList.vue?vue&type=script&lang=ts"
export * from "./AlternativeCardList.vue?vue&type=script&lang=ts"

import "./AlternativeCardList.vue?vue&type=style&index=0&id=4f1d3544&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1d3544"]])

export default __exports__